import { ICopyable } from '../../controls/common/icopyable';
import { ILogin } from './interfaces/login.interface';

export class Login implements ICopyable<Login> {
    public login: string = null;
    public password: string = null;
    public forceConnection: boolean = false;

    public createCopy(): Login {
        const instance = new Login();
        instance.login = this.login;
        instance.password = this.password;
        instance.forceConnection = this.forceConnection;
        return instance;
    }

    public static createFormCopy(login: Login): ILogin {
        const instance = new Login();
        instance.login = login.login;
        instance.password = login.password;
        instance.forceConnection = login.forceConnection;
        return instance;
    }

    public copyFrom(other: any) {
        this.login = other.login;
        this.password = other.password;
        this.forceConnection = other.forceConnection;
    }
}
